export default __webpack_public_path__ + "static/media/comic17_1.55677407.png";